import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { ResponseQueryByCriteria } from '../../shared/dto/responseQueryByCriteria';
import { Observable } from 'rxjs';
import { GenericService } from 'src/app/shared/GenericService';
import { TorneoDTO } from 'src/app/shared/dto/torneo/torneo';


@Injectable({
  providedIn: 'root'
})
export class TorneoService extends GenericService<TorneoDTO, number> {


  constructor(http: HttpClient) {
    super(http);
    this.url = environment.urlPrefix + '/services/rest/json/torneo';
  }

  public torneoListByStatus(pageNumber: number, pageSize: number, direction: string, sortField: string, status: string[] ): Observable<ResponseQueryByCriteria<TorneoDTO>> {
    let params = {};
    if (status != null) params["status"] = status;
    if (pageNumber != null) params["pageNumber"] = String(pageNumber);
    if (pageSize != null) params["pageSize"] = String(pageSize);
    if (direction != null) params["direction"] = direction;
    if (sortField != null) params["sortField"] = sortField;
    return this.http.get<ResponseQueryByCriteria<TorneoDTO>>(`${this.url}/torneoByStatus`, {
      params: params
    });
  }

  public iscriviCollaboratore(torneoDTO: TorneoDTO) : Observable<void> {
    return this.http.put<void>(`${this.url}/iscriviCollaboratore`, torneoDTO );
  }
}
